import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { RadioButton } from "primereact/radiobutton";

const ConfirmSiteSafety = ({
  confirmmessage,
  formValues,
  setFormValues,
  isUploadInProgress,
}: any) => {

  return (
    <div>
      <div className="tw-w-full tw-my-4">
        <DataTable
          value={confirmmessage}
          className="tw-w-full custome-leak-detection"
          showGridlines
        >
          <Column field="label" header="" className="lg:tw-w-full w-[270px] "></Column>
          <Column
            header="Yes"
            className="lg:tw-w-[100px]"
            body={() => (
              <RadioButton
                value="confirm"
                checked={
                  formValues?.confirmSiteSafety.value === true ? true : false
                }
                onChange={() =>
                  setFormValues((prev: any) => ({
                    ...prev,
                    confirmSiteSafety: {
                      ...prev.confirmSiteSafety,
                      value: true,
                    },
                  }))
                }
                disabled={isUploadInProgress}
                name="confirm"
              />
            )}
          />
          <Column
            header="No"
            className="lg:tw-w-[100px]"
            body={(rowData, { rowIndex }) => (
              <div className="tw-flex tw-gap-2 ">
                <RadioButton
                  value="notconfirm"
                  checked={
                    formValues?.confirmSiteSafety.value === false ? true : false
                  }
                  onChange={() =>
                    setFormValues((prev: any) => ({
                      ...prev,
                      confirmSiteSafety: {
                        ...prev.confirmSiteSafety,
                        value: false,
                      },
                    }))
                  }
                  disabled={isUploadInProgress}
                  name="notconfirm"
                />
              </div>
            )}
          />
        </DataTable>
      </div>
    </div>
  );
};

export default ConfirmSiteSafety;
